import { SVGProps, Ref, forwardRef } from "react";

const MessageTextSquareIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 17 18"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Message Text Square Icon"
    {...props}
  >
    <title id="Message Text Square Icon">Message Text Square Icon</title>
    <path
      d="M4.16671 5.41671H8.33337M4.16671 8.33337H10.8334M6.40316 13.3334H11.8334C13.2335 13.3334 13.9336 13.3334 14.4683 13.0609C14.9388 12.8212 15.3212 12.4388 15.5609 11.9684C15.8334 11.4336 15.8334 10.7335 15.8334 9.33337V4.83337C15.8334 3.43324 15.8334 2.73318 15.5609 2.1984C15.3212 1.72799 14.9388 1.34554 14.4683 1.10586C13.9336 0.833374 13.2335 0.833374 11.8334 0.833374H4.83337C3.43324 0.833374 2.73318 0.833374 2.1984 1.10586C1.72799 1.34554 1.34554 1.72799 1.10586 2.1984C0.833374 2.73318 0.833374 3.43324 0.833374 4.83337V15.2796C0.833374 15.7237 0.833374 15.9457 0.924398 16.0597C1.00356 16.1589 1.1236 16.2166 1.25049 16.2164C1.3964 16.2163 1.56977 16.0776 1.9165 15.8002L3.90438 14.2099C4.31047 13.885 4.51351 13.7226 4.73961 13.6071C4.94021 13.5046 5.15373 13.4297 5.37439 13.3844C5.6231 13.3334 5.88312 13.3334 6.40316 13.3334Z"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ForwardRef = forwardRef(MessageTextSquareIcon);
export default ForwardRef;
